import * as Icons from 'lucide-react';

/** "book-open" / "droplets" -> "BookOpen" / "Droplets" */
const toPascalCase = (name: string): string =>
  name
    .split(/[-_\s]+/)
    .filter(Boolean)
    .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
    .join('');

// Synonyms / backend names that aren't 1:1 lucide component names.
const ALIASES: Record<string, typeof Icons.Circle> = {
  run: Icons.Zap,
  zap: Icons.Zap,
  tree: Icons.TreePine,
  water: Icons.Droplet,
  meditation: Icons.Brain,
  sleep: Icons.Moon,
  fasting: Icons.Clock,
  fast: Icons.Clock,
};

/**
 * Resolve a habit icon name to a lucide component. AI suggestions can return any lucide
 * icon name (e.g. "brain", "clock", "droplets") that isn't in the curated picker — resolve
 * it dynamically against the full lucide catalogue before defaulting to Circle.
 */
export const resolveHabitIcon = (name: string): typeof Icons.Circle => {
  const key = (name || '').toLowerCase();
  if (ALIASES[key]) return ALIASES[key];
  const dynamic = (Icons as Record<string, unknown>)[toPascalCase(name || '')];
  if (typeof dynamic === 'function' || (typeof dynamic === 'object' && dynamic !== null)) {
    return dynamic as typeof Icons.Circle;
  }
  return Icons.Circle;
};
